module.exports = __webpack_public_path__ + "img/1-1.f93df4c1.png";